module.exports = __webpack_public_path__ + "c998efccb1d30ca2d13e251a679c0724.svg";